export default ({ request }) => ({
    mrpPendingGoodsQualityUserPageListApi(data = {}) {
      return request({
        url: '/factory/mrp/pending/goods/quality/user/page/list',
        method: 'post',
        data,
      })
    },
})